import { PravoNaGo } from './pravo-na-go';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseContainer, TabsContainerService, BaseTabsContainer, UserService } from 'yt-ng-framework';


@Component({
  selector: 'yt-pravo-na-go-tabs',
  templateUrl: './pravo-na-go-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class PravoNaGoTabsComponent
 extends BaseTabsContainer<PravoNaGo> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<PravoNaGo>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
